































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import BaseStationTrafficChart from "@/components/bss/BaseStationTrafficChart.vue";
import SectionHeader from "@/components/SectionHeader.vue";
import KeyValue from "@/components/KeyValue.vue";
import {CoreClient, curCoreClient} from "@/services/CoreClient";
import {BaseStation} from "@/types/core";
import EnterpriseId from "@/components/EnterpriseId.vue";
import BaseStationUniqueDevicesChart from "@/components/bss/BaseStationUniqueDevicesChart.vue";
// import BaseStationMeanPERChart from "@/components/bss/BaseStationMeanPERChart.vue";
import BaseStationCnxChart from "@/components/bss/BaseStationCnxChart.vue";
import BaseStationMetaSection from "@/components/device/meta/BaseStationMetaSection.vue";

@Component({
  components: {
    BaseStationCnxChart,
    BaseStationTrafficChart,
    BaseStationUniqueDevicesChart,
    // BaseStationMeanPERChart,
    SectionHeader,
    KeyValue,
    EnterpriseId,
    BaseStationMetaSection
  }
})
export default class BaseStationPage extends Vue {
  labels:object[] = [];
  lrrId:string = '';
  errorMsg:string = '';
  baseStation:BaseStation = {} as BaseStation;
  private range:string = '1d';
  private interval:string = '1h';
  private timeType:string = 'gw';

  gmapOptions:object = {
    streetViewControl: false,
    mapTypeControl: false,
    zoom: 10
  };

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  bus = new Vue();

  async mounted() {
    this.lrrId = this.$route.params['lrrId'];
    await this.loadBaseStation();
  }

  async loadBaseStation() {

    const reply = await this.coreClient.loadBaseStation(this.$route.params.lrrId);

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.httpCode === 404)
      return this.$router.push({name:'assets'});

    if(reply.errorMsg)
      return this.errorMsg = `Unable to retrieve base station info: ${reply.errorMsg}`;

    this.baseStation = reply.baseStation!;
  }

  async refresh() {
    this.bus.$emit('refresh-chart');
    await this.loadBaseStation();
  }

  async refreshBaseStationTrafficChart() {
    this.bus.$emit('refresh-chart');
  }

  get topIconList():any {

    let retList = [
      {name:'arrow-left', title:'back', event:'base-station-list', alert: false},
      {name:'sync-alt', title:'refresh', event:'refresh'},
    ];

    return retList;
  }

  get baseStationIconList():any {
    return [{name:'sync-alt', title:'refresh', event:'refresh'}];
  }

  backToBaseStations() {
    return this.$router.push({ name: 'assets'});
  }


  @Watch("range")
  async onRangeChange(newRange:string) {
    this.interval = this.calcInterval(this.range);
    this.bus.$emit('change-range', this.range, this.interval);
  }

  @Watch("timeType")
  async onTimeTypeChange() {
    this.bus.$emit('time-type-changed', this.timeType);
  }

  calcInterval(range:string):string {
    if (range === '1d' || range === '5d') {
      return '1h';
    }
    return '1d';
  }
}
